"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_query_1 = require("react-query");
var localization_1 = require("../../../../checkout/localization");
var api_1 = require("../../../api");
var callout_1 = require("../../../components/callout");
var error_message_1 = __importDefault(require("../../../components/error_message"));
var loading_modal_1 = __importDefault(require("../../../components/loading_modal"));
var save_button_1 = require("../../../components/save_button");
var update_address_1 = require("../../../mutations/update-address");
exports.default = (function (_a) {
    var _b, _c, _d, _e, _f;
    var groupedSubscription = _a.groupedSubscription, openDrawer = _a.openDrawer, setOpenDrawer = _a.setOpenDrawer;
    var address = groupedSubscription.address;
    var queryClient = (0, react_query_1.useQueryClient)();
    if (!address) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var fieldContainerClassName = function (fieldName) {
        return (0, classnames_1.default)({ 'form-input': true, 'with-error': errors && errors[fieldName], 'is-filled': formValues && !!formValues[fieldName] });
    };
    var _g = (0, react_hook_form_1.useForm)({
        mode: 'all',
        defaultValues: {
            first_name: address.first_name,
            last_name: address.last_name,
            company: address.company,
            phone: address.phone,
            address1: address.address1,
            address2: address.address2,
            city: address.city,
            province: address.province,
            country: address.country,
            zip: address.zip,
        },
    }), register = _g.register, handleSubmit = _g.handleSubmit, watch = _g.watch, errors = _g.errors;
    var formValues = watch();
    var countryCode = (0, localization_1.isCanadianAddressCountry)(formValues.country) ? 'CA' : 'US';
    var config = localization_1.LocaleConfig[countryCode];
    var callout = (0, callout_1.useCallout)().callout;
    var onShippingAddressSubmit = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mutateShippingAddress({
                        updates: data,
                        addressId: address.id,
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
    var _h = (0, react_query_1.useMutation)('updateShippingAddress', function (variables) { return (0, api_1.getSubscriptionAPIClient)().request(update_address_1.UPDATE_ADDRESS, variables); }, {
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        callout.success('Successfully Updated Shipping Address! (Refresh page to reflect pricing changes)');
                        return [4 /*yield*/, queryClient.invalidateQueries('getCustomerSubscriptions')];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    }), mutateShippingAddress = _h.mutateAsync, isLoading = _h.isLoading, error = _h.error, isError = _h.isError;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(loading_modal_1.default, { isLoading: isLoading, error: isError }),
        react_1.default.createElement("div", { className: 'horizontal-divider' }),
        react_1.default.createElement("a", { onClick: function () { return setOpenDrawer(openDrawer === 'shipping_address' ? undefined : 'shipping_address'); } },
            react_1.default.createElement("div", { className: 'account-subheader solid-border-top' },
                "Shipping Address",
                react_1.default.createElement("span", { className: "arrow ".concat(openDrawer === 'shipping_address' ? 'up' : 'down') })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", null, (_b = groupedSubscription.address) === null || _b === void 0 ? void 0 :
                    _b.address1,
                    " ", (_c = groupedSubscription.address) === null || _c === void 0 ? void 0 :
                    _c.address2),
                react_1.default.createElement("p", null, (_d = groupedSubscription.address) === null || _d === void 0 ? void 0 :
                    _d.city,
                    " ", (_e = groupedSubscription.address) === null || _e === void 0 ? void 0 :
                    _e.country,
                    " ", (_f = groupedSubscription.address) === null || _f === void 0 ? void 0 :
                    _f.zip))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('account-drawer-content', { open: openDrawer === 'shipping_address' }) },
            react_1.default.createElement("div", { className: 'padding-vertical-3' },
                react_1.default.createElement("div", { className: 'margin-bottom-8' },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: fieldContainerClassName('country') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("select", { name: 'country', autoComplete: 'country-name', ref: register({
                                        required: 'Required',
                                    }) },
                                    react_1.default.createElement("option", null, "Select"),
                                    react_1.default.createElement("option", { key: 'United States' }, "United States"),
                                    react_1.default.createElement("option", { key: 'Canada' }, "Canada")),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Country")),
                            react_1.default.createElement(error_message_1.default, { error: errors.country })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('first_name') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { type: 'text', name: 'first_name', autoComplete: 'given-name', spellCheck: false, autoCapitalize: 'off', placeholder: 'First Name', ref: register({
                                        required: {
                                            value: true,
                                            message: 'First name is required',
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "First Name")),
                            react_1.default.createElement(error_message_1.default, { error: errors.first_name })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('last_name') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'last_name', autoComplete: 'family-name', type: 'text', placeholder: 'Last Name', ref: register({
                                        required: {
                                            value: true,
                                            message: 'Last name is required',
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Last Name")),
                            react_1.default.createElement(error_message_1.default, { error: errors.last_name })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('company') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { type: 'text', name: 'company', autoComplete: 'company', spellCheck: false, autoCapitalize: 'off', placeholder: 'Company', ref: register({
                                        required: {
                                            value: false,
                                            message: '',
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Company (Optional)")),
                            react_1.default.createElement(error_message_1.default, { error: errors.company })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('address1') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { type: 'text', name: 'address1', autoComplete: 'address-line1', spellCheck: false, autoCapitalize: 'off', placeholder: 'Address', ref: register({
                                        required: {
                                            value: true,
                                            message: 'Address is required',
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Address")),
                            react_1.default.createElement(error_message_1.default, { error: errors.address1 })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('address2') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { type: 'text', name: 'address2', autoComplete: 'address-line2', spellCheck: false, autoCapitalize: 'off', placeholder: 'Apartment, suite, etc. (optional)', ref: register({
                                        required: {
                                            value: false,
                                            message: '',
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Apartment, suite, etc. (Optional)")),
                            react_1.default.createElement(error_message_1.default, { error: errors.address2 })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('city') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { type: 'text', name: 'city', autoComplete: 'shipping locality', spellCheck: false, autoCapitalize: 'off', placeholder: 'City', ref: register({
                                        required: {
                                            value: true,
                                            message: 'City is required',
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "City")),
                            react_1.default.createElement(error_message_1.default, { error: errors.city })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('province') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("select", { name: 'province', autoComplete: 'shipping region', ref: register({
                                        required: 'Required',
                                    }) },
                                    react_1.default.createElement("option", null, "Select"),
                                    config.states.map(function (state) { return (react_1.default.createElement("option", { key: state.name, value: state.name }, state.name)); })),
                                react_1.default.createElement("span", { className: 'placeholder' }, config.labels.state)),
                            react_1.default.createElement(error_message_1.default, { error: errors.province })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('zip') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { type: 'text', name: 'zip', autoComplete: 'shipping postal-code', spellCheck: false, autoCapitalize: 'off', placeholder: 'Address', ref: register({
                                        required: {
                                            value: true,
                                            message: 'ZIP Code is required',
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "ZIP Code")),
                            react_1.default.createElement(error_message_1.default, { error: errors.zip })),
                        react_1.default.createElement("div", { className: fieldContainerClassName('phone') },
                            react_1.default.createElement("label", null,
                                react_1.default.createElement("input", { name: 'phone', autoComplete: 'phone', type: 'text', placeholder: 'Phone', ref: register({
                                        required: {
                                            value: false,
                                            message: '',
                                        },
                                        minLength: {
                                            value: 6,
                                            message: 'Phone is too short',
                                        },
                                        maxLength: {
                                            value: 12,
                                            message: 'Phone is too long',
                                        },
                                    }) }),
                                react_1.default.createElement("span", { className: 'placeholder' }, "Phone (Optional)")),
                            react_1.default.createElement(error_message_1.default, { error: errors.phone })),
                        react_1.default.createElement(save_button_1.SaveButton, { onClick: onShippingAddressSubmit, isLoading: isLoading }),
                        isError && react_1.default.createElement(error_message_1.default, { error: { message: error } })))))));
});
